// @core/api/endpoints/document/get_numbering_scheme.ts
// Auto-generated by corebuilder. DO NOT EDIT.

import { getApiClient, type RequestOptions } from '../../client';
import type {
  NumberingSchemeResponse,
} from '../../../types/document';

const BASE_PATH = '/document';

/**
 * Get numbering scheme
 * Returns a numbering scheme by ID with current counter state.
 */
export async function GetNumberingScheme(
  scheme_id: string,
  options?: RequestOptions
): Promise<NumberingSchemeResponse> {
  const client = getApiClient();
  let requestPath = `${BASE_PATH}/numbering-schemes/:scheme_id`;
  requestPath = requestPath.replace(':scheme_id', encodeURIComponent(scheme_id));
  const requestOptions = options;
  return client.get<NumberingSchemeResponse>(requestPath, { ...requestOptions });
}
